// App.js
import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { checkAuthStatus } from "./redux/slices/authSlice";
import ProtectedRoute from "./components/ProtectedRoute";
import classes from "./App.module.css";

// Pages
import HomePage from "./pages/HomePage";
import Login from "./components/Login";
import Register from "./components/Register";
import Dashboard from "./pages/Dashboard";
import Insights from "./pages/Insights";
import Learn from "./pages/Learn";
import Connections from "./pages/Connections";

function App() {
  const dispatch = useDispatch();
  const { isLoggedIn, isInitialized } = useSelector((state) => state.auth);

  // Check authentication status on app start
  useEffect(() => {
    dispatch(checkAuthStatus());
  }, [dispatch]);

  // Show loading while checking authentication
  if (!isInitialized) {
    return (
      <div className={classes.appLoading}>
        <div className={classes.loadingSpinner}>
          <div className={classes.spinner}></div>
          <p className={classes.loadingText}>Loading Cent Capital...</p>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className={classes.App}>
        <Routes>
          {/* Public Routes */}
          <Route
            path="/"
            element={
              isLoggedIn ? <Navigate to="/dashboard" replace /> : <HomePage />
            }
          />
          <Route
            path="/login"
            element={
              isLoggedIn ? <Navigate to="/dashboard" replace /> : <Login />
            }
          />
          <Route
            path="/register"
            element={
              isLoggedIn ? <Navigate to="/dashboard" replace /> : <Register />
            }
          />

          {/* Protected Routes */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/insights"
            element={
              <ProtectedRoute>
                <Insights />
              </ProtectedRoute>
            }
          />
          <Route
            path="/learn"
            element={
              <ProtectedRoute>
                <Learn />
              </ProtectedRoute>
            }
          />
          <Route
            path="/connections"
            element={
              <ProtectedRoute>
                <Connections />
              </ProtectedRoute>
            }
          />

          {/* Catch all route - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
